import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UserProfileResponse } from '../models/user-profile.model';
import { PasswordChangeRequest, PasswordChangeResponse } from '../models/password-change.model';
import { SpecialtiesResponse, UserUpdateRequest, UserUpdateResponse } from '../models/user-update.model';
import { ProductsResponse } from '../models/product.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly defaultIdentifier = {
    tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
    app: "PortalAsistencia"
  };

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken');
    return new HttpHeaders({
      'Authorization': token || '',
      'Content-Type': 'application/json'
    });
  }

  private createRequestBody(petition: any) {
    return {
      identifier: this.defaultIdentifier,
      petition
    };
  }

  getUserProfile(cognitoId: any): Observable<UserProfileResponse> {
    const url = `${this.baseUrl}/user/${cognitoId}/details`;
    return this.http.get<UserProfileResponse>(url, { headers: this.getAuthHeaders() });
  }

  updatePassword(cognitoId: string, newPassword: string, email: string, currentPassword:string): Observable<PasswordChangeResponse> {
    const url = `${this.baseUrl}/user/${cognitoId}/update`;
    const body = this.createRequestBody({ newpassword: newPassword, email, oldpassword:currentPassword });
    return this.http.put<PasswordChangeResponse>(url, body);
  }

  updateUserInfo(cognitoId: string, data: any): Observable<UserUpdateResponse> {
    const url = `${this.baseUrl}/user/${cognitoId}/update`;
    const body = this.createRequestBody(data);
    return this.http.put<UserUpdateResponse>(url, body);
  }

  // Métodos específicos para mayor claridad
  updatePhone(cognitoId: string, mainPhone: number): Observable<UserUpdateResponse> {
    return this.updateUserInfo(cognitoId, { mainPhone });
  }

  updateAdditionalPhone(cognitoId: string, additionalPhone: number): Observable<UserUpdateResponse> {
    return this.updateUserInfo(cognitoId, { additionalPhone });
  }

  updateAdditionalEmail(cognitoId: string, additionalEmail: string): Observable<UserUpdateResponse> {
    return this.updateUserInfo(cognitoId, { additionalEmail });
  }

  updateContactMethod(cognitoId: string, contactMeans: string): Observable<UserUpdateResponse> {
    return this.updateUserInfo(cognitoId, { contactMeans });
  }

  getPolizas(cognitoId: string): Observable<any> {
    const url = `${this.baseUrl}/insurance/${cognitoId}/list`;
    return this.http.get<any>(url, { headers: this.getAuthHeaders() });
  }

  deleteProductFromPoliza(cognitoId: string, insurance: string, product: string): Observable<any> {
    const url = `${this.baseUrl}/insurance/${cognitoId}/delete`;
    const body = this.createRequestBody({
      insurance,
      product
    });
    return this.http.post<any>(url, body, { headers: this.getAuthHeaders() });
  }

  addProductToPoliza(cognitoId: string, numAssurance: string, productCode: string, startDate?: string, endDate?: string): Observable<any> {
    return this.managePolizaProduct(cognitoId, numAssurance, productCode, startDate, endDate);
  }

  private managePolizaProduct(cognitoId: string, numAssurance: string, productCode: string, startDate?: string, endDate?: string): Observable<any> {
    const url = `${this.baseUrl}/insurance/${cognitoId}/add`;
    const body = this.createRequestBody({
      num_assurance: numAssurance,
      startDate: startDate || new Date().toISOString().slice(0, 19).replace('T', ' '),
      endDate: endDate || new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().slice(0, 19).replace('T', ' '),
      coverages: [{ product: productCode }]
    });
    return this.http.post<any>(url, body, { headers: this.getAuthHeaders() });
  }

  getProducts(): Observable<ProductsResponse> {
    const url = `${this.baseUrl}/load/products`;
    console.log("productos",url)
    return this.http.get<ProductsResponse>(url);
  }

  getSpecialitys(idProduct: number): Observable<SpecialtiesResponse> {
    const url = `${this.baseUrl}/specialties/${idProduct}`;
    return this.http.get<SpecialtiesResponse>(url,{headers: this.getAuthHeaders()});
  }

  getUserAddresses(cognitoId: string): Observable<any[]> {
    const url = `${this.baseUrl}/user/${cognitoId}/addresses`;
    return this.http.get<any[]>(url, { headers: this.getAuthHeaders() });
  }

  changeCoverage(cognitoId: string, idProduct: string, idAssurance: string): Observable<any> {
    const url = `${this.baseUrl}/insurance/${cognitoId}/check`;
    const body = this.createRequestBody({
      idProduct,
      idAssurance
    });
    return this.http.post<any>(url, body, { headers: this.getAuthHeaders() });
  }

}
